import { twMerge } from "tailwind-merge";

interface StatusTagProps {
  text: string | React.ReactNode;
  className?: string;
}

export const StatusTag = ({ text, className }: StatusTagProps) => {
  return (
    <div
      className={twMerge(
        "bg-primary text-white px-2.5 py-[2.5px] rounded-md text-sm",
        className
      )}
    >
      {text}
    </div>
  );
};
